import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { CONTACT_PATH } from "../Routes/paths";

interface ContactProps {}

const Contact = ({}: ContactProps) => {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  return (
    <section className="my-[100px] lg:my-[180px] w-full  flex items-center justify-center">
      <div className="relative w-[70%] p-[50px] h-full bg-first_color rounded-[15px] flex flex-col items-center lg:items-start justify-center gap-4">
        <p
          className={`font-${
            i18n.language === "en" ? "Poppins" : "Almarai"
          } font-[700] text-[18px] lg:text-[32px] text-white lg:text-left text-center`}
        >
          {t("Connect With Us: Your Voice Heard")}
        </p>
        <p
          className={`max-w-[470px] ${
            i18n.language === "en"
              ? " lg:text-left"
              : "font-Almarai lg:text-right"
          } font-[600] text-[12px] lg:text-[16px] text-white lg:text-left text-center`}
        >
          {t(
            "Contact us today to know more about how we can help you grow your business and make it more success."
          )}
        </p>

        <p
          onClick={() => navigate(`${CONTACT_PATH}`)}
          className={`w-[150px] h-[40px] rounded-[10px] bg-white text-second_color text-[13px] font-${
            i18n.language === "en" ? "Poppins" : "Almarai"
          } font-[600] flex items-center justify-center cursor-pointer`}
        >
          {t("Contact Us")}
        </p>

        <img
          className={`hidden lg:block ${
            i18n.language === "en"
              ? "absolute right-[10%] bottom-0"
              : "absolute left-[10%] bottom-0"
          }`}
          src="../images/homeperson.png"
          alt=""
        />
      </div>
    </section>
  );
};

export default Contact;
